import { useForm } from "@inertiajs/inertia-react";
import Button from "app/components/Buttons/Button";
import Icon from "app/components/Icon";
import Img, { ResponsiveImage } from "app/components/Image";
import { useState } from "react";
import route from "ziggy-js";
import IconText from "../IconText";
import ImageInput from "./ImageInput";

export function ChangeImage({ image, name, label, height = "h-70px", removeMedia }: { image: ResponsiveImage | undefined, name: string, label?: any, height?: string, removeMedia?: string }) {
    const [change, setchange] = useState(false)
    const form = useForm({
        [name]: undefined as any
    });
    const { data, setData, post, processing } = form;

    const removeImage = (id) => {
        post(route('media.destroy', { media: id }), {
            preserveState: true,
            preserveScroll: true,
            onSuccess: () => { setchange(true); setData(name, undefined) }
        })
    }

    return (
        (change || !image)
            ? <ImageInput height={height} name={name} label={label} imagePreview />
            : <div className="mb-12px">
                <div>{label}</div>
                <div className={`${height} w-full relative flex items-center justify-center rounded overflow-hidden`}>
                    <Img className="object-cover object-center w-full h-full" src={image} alt={"Současný obrázek | Serafin byliny"} />
                    <div className="flex gap-12px absolute">
                        <Button className=" w-48px rounded-full" defaultPadding={false} href="#" onClick={(e) => { e.preventDefault(); setchange(true); setData(name, undefined) }}><Icon name="plus" /></Button>
                        {removeMedia && <Button className=" bg-red hover:bg-red-dark text-white" defaultColor={false} href="#" onClick={(e) => { e.preventDefault(); removeImage(removeMedia) }}>{(processing) ? <div className="spinner2 animate-spin" /> : <Icon name={"cross"} />}</Button>}
                    </div>
                </div>
            </div>
    )
}